import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useState } from 'react';
import { createUser, login } from '../../api/api'
import { useNavigate } from 'react-router-dom';

function RegisterModal(props) {
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const navigate = useNavigate();

    const handleSubmit = (event) => {
        event.preventDefault();
        createUser(email, firstName, lastName, name, password, confirmPassword).then(() => {
            return login(email, password);
        }).then(loginData => {
            props.setToken(loginData.token);
            if (props.nextPage) {
                const nextPage = props.nextPage;
                props.setNextPage('');
                navigate(nextPage);
            }
            props.setShow(false);
        });
    };

    return (
        <Modal show={props.show} onHide={() => props.setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Register</Modal.Title>
            </Modal.Header>

            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="registerForm.Email">
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" onChange={(e) => setEmail(e.target.value)} />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="registerForm.FirstName">
                        <Form.Label>First Name</Form.Label>
                        <Form.Control type="text" onChange={(e) => setFirstName(e.target.value)} />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="registerForm.LastName">
                        <Form.Label>Last Name</Form.Label>
                        <Form.Control type="text" onChange={(e) => setLastName(e.target.value)} />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="registerForm.Name">
                        <Form.Label>Screen Name (only name users will see)</Form.Label>
                        <Form.Control type="text" onChange={(e) => setName(e.target.value)} />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="registerForm.Password">
                        <Form.Label>Password (at least 8 characters)</Form.Label>
                        <Form.Control type="password" onChange={(e) => setPassword(e.target.value)} />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="registerForm.ConfirmPassword">
                        <Form.Label>Confirm Password</Form.Label>
                        <Form.Control type="password" onChange={(e) => setConfirmPassword(e.target.value)} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="ms-auto" onClick={() => props.setShow(false)}>Cancel</Button>
                    <Button variant="primary" type="submit" onClick={handleSubmit}>Register</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default RegisterModal;